export default "__VITE_ASSET__4p0zre6Q__"